import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { Icon } from '../Icon/Icon.js';
import { defaultStyle } from './defaultStyle.js';
const styles = {
    ...defaultStyle,
    border: 'border border-transparent rounded-md',
    position: 'absolute flex items-center justify-center',
};
export const renderUserGeolocation = (map, yandexMaps, className) => {
    const setUserGeoLocation = () => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        yandexMaps.geolocation
            .get({
            provider: 'yandex',
            autoReverseGeocode: true,
            mapStateAutoApply: true,
        })
            .then(function (result) {
            map.current.geoObjects.add(result.geoObjects);
        });
    };
    return (_jsx("div", { className: `select-none cursor-pointer py-m w-12 bg-white ${Object.values(styles).join(' ')} ${className}`, onClick: setUserGeoLocation, children: _jsx(Icon, { name: "UserGeoLocationIcon", width: "20", height: "16" }) }));
};
//# sourceMappingURL=renderUserGeolocation.js.map